import {
    Button,
    Card,
    CardHeader,
    CardFooter,
    Text,
    Title3,
    Body1,
    Divider,
    makeStyles,
    tokens
} from "@fluentui/react-components";
import { useNavigate } from 'react-router-dom';
import { navigateSafely } from '../../../utils/navigation';
import { useTranslation } from 'react-i18next';
import { MailWithQuestion } from '@si/fib-icons';
import {
    FlashFilled,
    SettingsFilled
} from "@fluentui/react-icons";

const useStyles = makeStyles({
    root: {
        padding: tokens.spacingVerticalL,
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacingVerticalL,
    },

    header: {
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacingVerticalS,
    },

    quickSaveCard: {
        border: `1px solid ${tokens.colorBrandStroke1}`,
    },

    cardFooter: {
        display: "flex",
        justifyContent: "center",
    },

    advancedSaveCard: {
        border: `1px solid ${tokens.colorNeutralStroke1}`,
    },

    advancedCardFooter: {
        display: "flex",
        justifyContent: "center",
    },
});

export const MailArchiveHome = () => {
    const styles = useStyles();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleQuickSave = () => {
        navigateSafely(navigate, '/quicksave');
    };

    const handleAdvancedSave = () => {
        navigateSafely(navigate, '/archiveMail');
    };

    return (
        <div className={styles.root}>
            {/* Header */}
            <div className={styles.header}>
                <Title3>
                    <MailWithQuestion size={24} /> {t('Not archived in 360°')}
                </Title3>
                <Body1>
                    {t('This email is not yet saved to 360°. Choose how you want to continue.')}
                </Body1>
            </div>

            {/* Quick Save (Primary) */}
            <Card className={styles.quickSaveCard}>
                <CardHeader
                    image={<FlashFilled />}
                    header={<Text weight="semibold">{t('Quick Save')}</Text>}
                    description={
                        <Text>
                            {t('Save within the addin using default values and limited options.')}
                        </Text>
                    }
                />

                <CardFooter className={styles.cardFooter}>
                    <Button
                        appearance="primary"
                        onClick={handleQuickSave}
                    >
                        {t('Save to 360')}
                    </Button>
                </CardFooter>
            </Card>

            <Divider>{t('or')}</Divider>

            {/* Advanced Save (Secondary) */}
            <Card className={styles.advancedSaveCard}>
                <CardHeader
                    image={<SettingsFilled />}
                    header={<Text weight="semibold">{t('Advanced Save')}</Text>}
                    description={
                        <Text>
                            {t('Use the 360° wizard with more features for saving documents.')}
                        </Text>
                    }
                />

                <CardFooter className={styles.advancedCardFooter}>
                    <Button
                        appearance="outline"
                        onClick={handleAdvancedSave}
                    >
                        {t('Open advanced 360° Wizard')}
                    </Button>
                </CardFooter>
            </Card>
        </div>
    );
};
